import { render, staticRenderFns } from "./ReturningStore.vue?vue&type=template&id=03938695"
import script from "./ReturningStore.vue?vue&type=script&lang=js"
export * from "./ReturningStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports